import {wymsFetch, getParams} from '@/utils/fetch';

// 查询权限树
export function queryApiPermTree(args) {
    const params = getParams();
    params.append('module', args.module);

    return wymsFetch({
        url: 'apiManage/queryApiPermTree',
        method: 'GET',
        params
    });
}

// 查询Api权限的列表
export function queryApiPermissionByPid(args) {
    const params = getParams(true, args);
    params.append('apiName', args.apiName);
    params.append('pid', args.pid);

    return wymsFetch({
        url: 'apiManage/queryApiPermissionByPid',
        method: 'GET',
        params
    });
}

// 删除单条/多条API权限
export function deleteApiPermission(args) {
    const params = getParams();
    params.append('ids', args.ids);
    params.append('pid', args.pid);

    return wymsFetch({
        url: 'apiManage/deleteApiPermission',
        method: 'GET',
        params
    });
}
// 新增API权限
export function insertApiPermission(args) {
    const params = getParams();
    params.append('apiName', args.apiName);
    params.append('limitingNumber', args.limitingNumber);
    params.append('limitingTime', args.limitingTime);
    params.append('parentId', args.parentId);
    params.append('urlDescribe', args.urlDescribe);
    params.append('urlPath', args.urlPath);

    return wymsFetch({
        url: 'apiManage/insertApiPermission',
        method: 'POST',
        data: params
    });
}

// 编辑权限
export function updateApiPermission(args) {
    const params = getParams();
    params.append('apiName', args.apiName);
    params.append('limitingNumber', args.limitingNumber);
    params.append('limitingTime', args.limitingTime);
    params.append('id', args.id);
    params.append('parentId', args.parentId);
    params.append('urlDescribe', args.urlDescribe);
    params.append('urlPath', args.urlPath);

    return wymsFetch({
        url: 'apiManage/updateApiPermission',
        method: 'POST',
        data: params
    });
}

// 查询更应用挂钩的权限文件夹
export function queryApiNameByModuleId(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'apiManage/queryApiNameByModuleId',
        method: 'GET',
        params
    });
}
// 查询更应用挂钩的权限文件夹
export function queryApiPermission(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'apiManage/queryApiPermission',
        method: 'GET',
        params
    });
}
// 查询应用权限
export function queryApiListByModuleId(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'apiManage/queryApiListByModuleId',
        method: 'GET',
        params
    });
}

//
export function insertModuleApiApplication(args) {
    return wymsFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'apiManage/insertModuleApiApplication',
        method: 'POST',
        data: JSON.stringify(args)
    });
}



// WEBPACK FOOTER //
// ./src/api/apiPermission.js